
/*
form is where we have all the details for all the inputs
for the entity  forms
each entity has their own form
*/
export const form   =  [
 
	{	
		name: "code", 
		value:'', 		
		id:'warehousepurchase_form_code',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "provider_id", 
		value:[],
		valueFull:'', 		
		id:'warehousepurchase_form_provider_id',
		html:'',
		type:'autocomplete',
		required: true,  
	},
	{	
		name: "shipping", 
		value:'', 		
		id:'warehousepurchase_form_shipping',
		html:'',
		type:'multiselect',
		options :["ordered", "shipped", "delivered"],
		required: false,  
	},
	{	
		name: "reference_number", 
		value:'', 		
		id:'warehousepurchase_form_reference_number',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "delivered_date", 
		value:'0000-00-00',
		date: true,	
		id:'warehousepurchase_form_delivered_date',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "signature", 
		value:[], //don't forget this on signature	
		id:'warehousepurchase_form_signature', //should be the same thatn in signature-pads
		html:'',
		type:'signature',
		required: true,  //this the mandatory
		edit: true, // can be edited or not
	 },
]



//we use this for check changes on form	
export const formCopy = JSON.parse(JSON.stringify(form)) 

